var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7436 6H15.2564C10.7046 6 7 9.70462 7 14.2564V25.7436C7 30.2954 10.7046 34 15.2564 34H26.7436C31.2954 34 35 30.2954 35 25.7436V14.2564C35 9.70462 31.2954 6 26.7436 6ZM9.15385 25.7436V14.2564C9.15385 10.8964 11.8964 8.15385 15.2564 8.15385H26.7436C30.1036 8.15385 32.8462 10.8964 32.8462 14.2564V20.359H31.0082C27.8923 20.359 25.121 21.8523 23.3549 24.1641C22.1918 24.6379 21.201 24.6667 21 24.6667C18.0277 24.6667 16.3046 22.4697 16.1179 22.2256C15.759 21.7518 15.0841 21.6513 14.6103 22.0103C14.1364 22.3692 14.0359 23.0441 14.3949 23.5179C14.8113 24.0636 17.0656 26.8205 21 26.8205C21.1579 26.8205 21.4882 26.8205 21.9333 26.7487C21.56 27.7682 21.359 28.8595 21.359 30.0082V31.8462H15.2564C11.8964 31.8462 9.15385 29.1036 9.15385 25.7436ZM26.7436 31.8462H23.5128V30.0082C23.5128 25.8728 26.8728 22.5128 31.0082 22.5128H32.8462V25.7436C32.8462 29.1036 30.1036 31.8462 26.7436 31.8462Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1282 18.2052C18.7169 18.2052 19.2051 17.717 19.2051 17.1283V15.6924C19.2051 15.1037 18.7169 14.6155 18.1282 14.6155C17.5395 14.6155 17.0513 15.1037 17.0513 15.6924V17.1283C17.0513 17.717 17.5395 18.2052 18.1282 18.2052Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8718 18.2052C24.4606 18.2052 24.9488 17.717 24.9488 17.1283V15.6924C24.9488 15.1037 24.4606 14.6155 23.8718 14.6155C23.2831 14.6155 22.7949 15.1037 22.7949 15.6924V17.1283C22.7949 17.717 23.2831 18.2052 23.8718 18.2052Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.5c0e06ce.svg";
export { ForwardRef as ReactComponent };